import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {AuthorizationService} from '../../../modules/shared/service/authorization.service';
import {map} from 'rxjs/internal/operators';

@Injectable()
export class ChappsAccountService {

  private readonly APPLICATIONS_ROUTE = environment.accountSiteUrl + 'api/applications';

  constructor(private httpClient: HttpClient, private authorizationService: AuthorizationService) {
  }

  public getApplications(): Observable<any[]> {
    const options = {
      headers: {
        'jwt': this.authorizationService.getToken(),
        'refreshtoken': this.authorizationService.getRefreshToken(),
      }
    };
    return this.httpClient.get<any[]>(this.APPLICATIONS_ROUTE, options).pipe(
      map(apps => apps.map(app => {
        app.thumbnailUrl = `${environment.accountSiteUrl}assets/platforms/${app.type}.png`;
        return app;
      }))
    );
  }
}
